<template>
    <div class="page-wrapper">
        <div class="page-section">
            <div class="cg-crumb">
                <btn-back />
                <span class="item">订单管理</span>
                <em class="gap">/</em>
                <span class="item">下单详情</span>
            </div>
            <div class="cg-main-title">下单详情 <span style="margin-left: 20px;">{{orderDetail.order_number}}</span></div>
            <div class="header-handle-box">
                <h3 class="state">
                    当前订单状态：
                    <!-- {{orderTakedStateText}} -->
                    
                    <div v-if="clearState" class="stateInline">
                        <!-- <el-tag type="primary" size="medium">{{clearState}}</el-tag> -->
                        {{clearState}}
                        <span class="">{{liquidateOrderNumber}}</span>
                    </div>
                    <div class="stateInline" v-if="!clearState" >
                        <!-- <el-tag type="success" size="medium">{{stateWord[checkState]}}核销</el-tag> -->
                        {{stateWord[checkState]}}核销
                    </div>
                    <div class="stateInline" v-if="!clearState&&payState&&payState!='noNeed'">
                        <!-- <el-tag type="warning" size="medium">{{stateWord[payState]}}付款</el-tag> -->
                        {{stateWord[payState]}}付款
                    </div>
                </h3>
                <div class="btns">
                    <button class="cg-btn big red" @click="toLiquidationDetail" v-if="clearState">查看清算</button>
                    <button class="cg-btn big red" @click="openToClearModal" v-if="!clearState">发起清算</button>
                    <button class="cg-btn big red" @click="checkClick"  v-if="!clearState&&checkState!='all'">核销</button>
                    <!-- <button class="cg-btn red" @click="payClick">付款</button> -->
                    <!-- <button class="cg-btn red" @click="sendBillInfo" v-if="!clearState">测试：给自己发账单</button> -->
                </div>
            </div>
        </div>
        <div class="page-section" v-if="billList_apply.length > 0">
          <div class="cg-mod-title mgt-0">平台应向销售商打款账单</div>
          <ul class="time-line">
            <li class="item" v-for="(item, index) in billList_apply" :key="index">
              <div class="item-tail"></div>
              <div class="item-node"></div>
              <div class="item-content">
                <div class="item-tit">
                  <strong class="item-tit-strong">申请额度通过，平台应向您支付的第{{billList_apply.length - index}}个账单</strong>
                  <span class="item-tit-during">（审核通过账单生成时间：{{item.order_submit_time}}）</span>
                </div>
                <div class="item-sum-data">
                  <div >本次您申请总金额：{{item.order_bill_amount}} 元</div>
                  <div v-if="item.amountToBeConfirmed>0">平台已支付未被确认金额：（待您确认）{{item.amountToBeConfirmed}}  元</div>
                  <div v-if="item.remainAmount>0">平台还需支付总金额：<span class="red">{{item.remainAmount}} 元</span></div>
                </div>
                <div class="item-box">
                  <ul class="sub-time-line">
                    <template v-if="item.orderPaymentList">
                      <li class="sub-item" v-for="(child, pay_i) in item.orderPaymentList" :key="pay_i">
                        <div class="pdb-12">
                          <span class="title">
                            <span class="time">{{child.order_submit_time}}</span>
                           平台上传了付款凭证，打款了{{child.order_payment_amount}}元
                          </span>
                          <el-tag type="success" v-if="child.order_state == 'y'">已确认收到</el-tag>
                          <el-tag type="danger" v-if="child.order_state == 'n'">您已驳回</el-tag>
                          
                          <button class="cg-btn big red" v-if="child.order_state == 'p'" @click="openCheckApplyPay(child)">待您确认</button>
                        </div>
                        <div class="pdb-12">
                         <template v-for="(img_ele, img_index) in child.imageFiles">
                            <el-image :key="img_index" v-if="img_ele" class="img" :src="img_ele" fit="cover"
                              :preview-src-list="child.imageFiles"></el-image>
                          </template>
        
                          <span v-if="child.order_payment_memo" class="pay-info grey">
                            说明：{{child.order_payment_memo}}
                          </span>
                        </div>
                      </li>
                    </template>
        
                    <!-- <li class="sub-item">
                      <div class="pdb-6">
                        <span class="time">{{item.order_submit_time}}</span>
                        系统依据平台规则向销售商发布了付款账单
                      </div>
                      <div class="grey pdb-12">
                        销售商本次付款周期期间明细账单：<br>
                        本周期内已核销总数：件
                        <br>
                        <template >
                          剩余未核销数： 件 <br>
                        </template>
                        销售商需支付金额：<span class="green">{{item.order_bill_amount}} 元</span>
                      </div>
                    </li>
                    <li class="sub-item">
                      <div class="pdb-6">
                        <span class="time">tine</span>
                        销售商第1次核销
                      </div>
                      <div class="grey pdb-12">
                        核销前未核销总数666 件，核销 666 件，剩余未核销
                       666件。<br>
                        核销应付款：666
                        <span class="green">666元</span>
                      </div>
                    </li> -->
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="page-section" v-if="applyLists.length > 0">
            <div class="cg-mod-title mgt-0">申请记录</div>
            <ul class="time-line">
                <li class="item" v-for="(item, index) in applyLists" :key="index">
                    <div class="item-tail"></div>
                    <div class="item-node"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            销售商第{{applyLists.length - index}}次申请 ({{item.request_submit_time}})
                        </div>
                        <div class="item-box">
                            <div class="grey">
                                <div style="display: inline-block;width: 200px;">申请金额：{{item.request_amount}} 元</div>
                                <el-tag type="success" v-if="item.request_state == 'y'">平台已确认</el-tag>
                                
                                <el-tag type="danger" v-if="item.request_state == 'p'">待平台审核</el-tag>
                                
                                <el-tag type="info" v-if="item.request_state == 'n'">平台已驳回</el-tag>
                                <span v-if="item.request_state == 'n'&&item.request_last_update_memo">(驳回理由：{{item.request_last_update_memo}})</span>
                                <br>
                                申请备注：{{item.request_content}} <br>
                               <template v-for="(img_ele, img_index) in item.imgArr">
                                    <el-image
                                      :key="img_index"
                                      v-if="img_ele"
                                      class="img"
                                      :src="img_ele"
                                      fit="cover"
                                      :preview-src-list="item.imgArr"
                                  ></el-image>
                                </template>
                                
                               
                                
                            </div>    
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        
        <div class="page-section" v-if="billList_dealer.length > 0">
            <div class="cg-mod-title mgt-0" style="font-size: 20px;">销售商付款记录：</div>
            <ul class="time-line">
                <li class="item" v-for="(item, index) in billList_dealer" :key="index">
                    <div class="item-tail"></div>
                    <div class="item-node"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            <strong class="item-tit-strong" style="font-size: 20px;font-weight: bold;">销售商第{{billList_dealer.length - index}}个付款周期</strong>
                            <span class="item-tit-during" style="font-size: 15px;color:#666;">（{{item.bill_start_time}} 至 {{item.bill_end_time}}）</span>
                            <button class="cg-btn red"  @click="payClick(item)" v-if="!clearState&&item.rest_pay_amount>0">付款</button>
                        </div>
                        <div class="item-sum-data" style="font-size: 18px;">
                            <div class="mt10">
                                本周期内已核销总数：
                                <span class="bold">
                                    {{item.orderEstablishList[0] ? (item.orderEstablishList[item.orderEstablishList.length-1].beforeOrderQuantity - item.orderEstablishList[0].restQuantity) : 0}}件
                                </span>
                            </div>
                            <div class="mt10">
                                本周期账单总金额： <span class="bold">{{item.order_bill_amount}}</span>  元
                            </div>
                            <div class="mt10">
                                本期账单累计成功支付（被平台确认）：<span  class="bold">{{item.order_pay_amount||0}}</span>  元
                            </div>
                            <div class="mt10">
                                本期账单提交且未被平台确认金额：<span  class="bold">{{item.amountToBeConfirmed || 0}}</span>  元
                            </div>
                            <div class="mt10">
                                本期账单您需再提交支付金额：<span class="red bold">{{item.rest_pay_amount_subConfirm}} 元</span>
                            </div>
                            
                            
                            
                            
                        </div>
                        <div class="item-box">                   
                            <ul class="sub-time-line">
                              <template v-if="item.orderPaymentList">
                                <li  class="sub-item" v-for="(pay_ele, pay_i) in item.orderPaymentList" :key="pay_i">
                                  <div class="pdb-12">
                                    <span class="title">
                                       <span class="time">{{pay_ele.order_submit_time}}</span>
                                       销售商上传了付款凭证，支付了{{pay_ele.order_payment_amount}}元
                                    </span>
                                    <el-tag type="success" v-if="pay_ele.order_state == 'y'">平台已确认</el-tag>
                                    <el-tag type="info" v-if="pay_ele.order_state == 'n'">平台已驳回</el-tag>
                                    <el-tag type="danger" v-if="pay_ele.order_state == 'p'">待平台审核</el-tag>
                                  </div>
                                  <div class="pdb-12">
                                    <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                                        <el-image
                                          :key="img_index"
                                          v-if="img_ele"
                                          class="img"
                                          :src="img_ele"
                                          fit="cover"
                                          :preview-src-list="pay_ele.imageFiles"
                                      ></el-image>
                                    </template>
                                    
                                    <span v-if="pay_ele.order_payment_memo" class="pay-info grey">
                                      说明：{{pay_ele.order_payment_memo}}
                                    </span>
                                  </div>
                                  <!-- <div v-if="pay_ele.order_payment_memo" class="pdb-12 grey">
                                    说明：{{pay_ele.order_payment_memo}}
                                  </div> -->
        
                                </li>
                              </template>
                              
                              <!-- <li class="sub-item">
                                  <div class="pdb-12">销售商于2020年4月1日 12:30:40上传了付款凭证。</div>
                              </li>
                              <li class="sub-item">
                                  <div class="pdb-12">平台于2020年3月23日 16：12：32 确认了销售的付款</div>
                              </li> -->
                              <li class="sub-item">
                                  <div class="pdb-6">
                                      <span class="time">{{item.order_submit_time}}</span>
                                    系统依据平台规则向销售商发布了付款账单
                                    </div>
                                  <div class="grey pdb-12">
                                      销售商本次付款周期期间明细账单：<br>
                                      本周期内已核销总数：{{item.orderEstablishList[0] ? (item.orderEstablishList[item.orderEstablishList.length-1].beforeOrderQuantity - item.orderEstablishList[0].restQuantity) : 0}}件 <br>
                                      <template v-if="item.orderEstablishList[0]">
                                        剩余未核销数：{{item.orderEstablishList[0].restQuantity}} 件 <br>
                                      </template>
                                      销售商需支付金额：<span class="">{{item.order_bill_amount}} 元</span>
                                  </div>
                              </li>
                              <li class="sub-item" v-for="(check_ele, check_i) in item.orderEstablishList" :key="check_i + 1000">
                                    <div class="pdb-6">
                                        <span class="time">{{check_ele.order_submit_time}}</span>
                                        销售商第{{item.orderEstablishList.length - check_i}}次核销
                                    </div>  
                                    <div class="grey pdb-12">
                                        <!-- 核销时间：{{check_ele.order_submit_time}} <br> -->
                                        核销前未核销总数 {{check_ele.beforeOrderQuantity}} 件，核销 {{check_ele.orderEstablishQuantity}} 件，剩余未核销 {{check_ele.restQuantity}} 件。<br>
                                        核销应付款：{{check_ele.orderEstablishQuantity}}(件)x{{check_ele.unitPrice}}(元/件)x{{check_ele.supplierRate}}(%)= <span class="">{{check_ele.sumMoney}} 元</span>
                                    </div>    
                              </li>
                              
                          </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
       
        <div class="page-section" v-if="billList_platform.length > 0">
            <div class="cg-mod-title mgt-0">平台结款记录：</div>
            <ul class="time-line">
                <li class="item" v-for="(item, index) in billList_platform" :key="index">
                    <div class="item-tail"></div>
                    <div class="item-node"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            <strong class="item-tit-strong">平台第{{billList_platform.length - index}}个结款周期</strong>
                            <span class="item-tit-during">（周期范围：{{item.bill_start_time}} 至 {{item.bill_end_time}}）</span>
                        </div>
                        <div class="item-sum-data">
                            本周期账单总金额：{{item.order_bill_amount}}  元<br>
                            平台已支付总金额（被供应商确认）：{{item.order_pay_amount}} 元<br>
                            平台还需支付总金额：<span class="red">{{item.rest_pay_amount}} 元</span><br>
                        </div>
                        <div class="item-box">
                            <ul class="sub-time-line">
                               <template v-if="item.orderTransferList">
                                <li  class="sub-item" v-for="(pay_ele, pay_i) in item.orderTransferList" :key="pay_i">
                                  <div class="pdb-12">
                                    <span class="title"> 
                                        <span class="time">{{pay_ele.order_submit_time}}</span>
                                        平台方上传了结款凭证，支付了{{pay_ele.order_payment_amount}}元
                                    </span>
                                     <el-tag type="danger" v-if="pay_ele.order_last_update_time">供应商已确认</el-tag>
                                     <el-tag type="danger" v-if="!pay_ele.order_last_update_time">待供应商确认</el-tag>
                                     
                                     <!-- <button class="cg-btn red-border mgl-16" v-if="!orderDetail.liquidateOrderState && !pay_ele.order_last_update_time" @click="getPlatformPayDetail(item, pay_ele)">确认平台付款凭证</button> -->
                                  </div>
                                  <div class="pdb-12">
                                    <template v-for="(img_ele, img_index) in pay_ele.imageFiles">
                                        <el-image
                                          :key="img_index"
                                          v-if="img_ele"
                                          class="img"
                                          :src="img_ele"
                                          fit="cover"
                                          :preview-src-list="pay_ele.imageFiles"
                                      ></el-image>
                                    </template>
                                    
                                    <span v-if="pay_ele.order_payment_memo" class="pay-info grey">
                                      说明：{{pay_ele.order_payment_memo}}
                                    </span>
                                  </div>
                                </li>
                              </template>
                               <li class="sub-item">
                                   <div class="pdb-6">
                                       <span class="time">{{item.order_submit_time}}</span>
                                       系统依据平台规则向供应商发布了以上已核销且销售商已付款的订单明细。
                                    </div>
                                    <div class="grey pdb-12">
                                       本期平台应向供应商支付<span class="green">{{item.order_bill_amount}}</span>元
                                    </div>
                               </li>
                           </ul>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="page-section" v-if="checkSaleHistory.length > 0">
            <div class="cg-mod-title mgt-0">核销记录</div>
            <ul class="time-line">
                <li class="item" v-for="(item, index) in checkSaleHistory" :key="index">
                    <div class="item-tail"></div>
                    <div class="item-node"></div>
                    <div class="item-content">
                        <div class="item-tit">
                            销售商第{{checkSaleHistory.length - index}}次核销
                        </div>
                        <div class="item-box">
                            <div class="grey">
                                核销时间：{{item.order_submit_time}} <br>
                                核销前未核销总数 {{item.beforeOrderQuantity}} 件，核销 {{item.orderEstablishQuantity}} 件，剩余未核销 {{item.restQuantity}} 件。<br>
                                核销应付款：{{item.orderEstablishQuantity}}(件)x{{item.unitPrice}}(元/件)x{{item.supplierRate}}(%)= <span class="green">{{item.sumMoney}} 元</span>
                            </div>    
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        

        
        <!-- 商品信息 -->
        <div class="page-section">
            <div class="order-detail-table">
                <table class="table">
                    <tr class="th">
                        <th width="40%">商品</th>
                        <th width="20%">款号</th>
                        <th width="20%">供应商</th>
                        <th width="20%">总下单数</th>
                    </tr>
                    <tr>
                        <td>
                            <div class="td-1-wrap">
                                <el-image
                                    class="img"
                                    :src="imgUrl"
                                    fit="cover"
                                    :preview-src-list="srcList"
                                ></el-image>
                                <div class="title">{{orderDetail.item_name}}</div>
                            </div>
                        </td>
                        <td>{{orderDetail.item_style_number}}</td>
                        <td>{{orderDetail.supplierName}}</td>
                        <td>{{orderDetail.order_purchase_quantity}}</td>
                    </tr>
                </table>
                <div class="rate-info">说明：分佣比例为“销售商 : 供应商={{orderDetail.dealer_rate}}% : {{orderDetail.supplier_rate}}%”；平台服务费为您分佣后获得收益的{{serviceFeeShow}}，如 单件所收服务费=单价x分佣比例x{{serviceFeeShow}}</div>
                <div class="address-wrap" v-if="orderDetail.addressInfo">
                    <div class="address-label">销售商收货地址</div>
                    <div class="address-content">
                        <div class="line">
                            <span>姓名：{{orderDetail.addressInfo.address_contact_name}}</span>
                            <span class="gap">手机号：{{orderDetail.addressInfo.address_contact_phone}}</span>
                        </div>
                        <div class="line">地址：
                            {{orderDetail.addressInfo.region_province_string }}
                            {{orderDetail.addressInfo.region_city_string }}
                            {{orderDetail.addressInfo.region_district_string }}
                            {{orderDetail.addressInfo.address_string }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        <div class="page-section">
            <div class="cg-mod-title mgt-0">下单订单明细</div>
            <div class="basic-info mgt-24">
                <el-row>
                    <el-col :span="8"><div class="line">
                        <span class="lab">下单订单号： </span>
                        <span class="val">{{orderDetail.order_number}}</span>
                    </div></el-col>
                    <el-col :span="16"><div class="line">
                        <span class="lab">下单时间：</span>
                        <span class="val">{{orderDetail.order_submit_time}} </span>
                    </div></el-col>
                    <el-col :span="8"><div class="line blue">
                        <span class="lab">下单时价格： </span>
                        <span class="val">{{orderDetail.item_order_price}}元/件</span>
                    </div></el-col>
                    <el-col :span="8"><div class="line blue">
                        <span class="lab">订单总计：</span>
                        <span class="val">{{orderDetail.order_purchase_quantity}}件</span>
                    </div></el-col>
                    <el-col :span="8"><div class="line blue">
                        <span class="lab">订单总价：</span>
                        <span class="val">{{orderDetail.order_purchase_amount}}元</span>
                    </div></el-col>
                </el-row>
            </div>
            <div class="take-order-table">
                <table class="table">
                    <thead>
                        <tr class="th">
                            <th width="15%">颜色</th>
                            <th width="25%">尺码</th>
                            <th width="25%">下单数量</th>
                            <th width="">小计</th>
                        </tr>
                    </thead>
                    <tbody v-for="(p_item, p_index) in orderSizeColorArr" :key="p_index">
                        <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index" >
                        <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
                        <td>{{s_item.name}}</td>
                        <td>
                            {{s_item.number}}
                        </td>
                        <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.colorChoseTotal}}</td>
                        </tr>             
                    </tbody>
                </table>
            </div>
        </div>

        <div class="page-section" v-if="historyLockOrderList.length > 0">
            <div class="cg-mod-title mgt-0">锁仓订单明细</div>
            <div v-for="(item, index) in historyLockOrderList" :key="index">
                <div class="basic-info mgt-24">
                    <el-row>
                        <el-col :span="8"><div class="line">
                            <span class="lab">锁仓订单号： </span>
                            <span class="val">{{item.order_number}}</span>
                        </div></el-col>
                        <el-col :span="8"><div class="line">
                            <span class="lab">发起锁仓时间：</span>
                            <span class="val">{{item.reserve_order_submit_time}}</span>
                        </div></el-col>
                        <el-col :span="8"><div class="line">
                            <span class="lab"> 同意锁仓时间： </span>
                            <span class="val">{{item.reserve_order_last_update_time}}</span>
                        </div></el-col>
                        <el-col :span="8"><div class="line blue">
                            <span class="lab">下单时价格： </span>
                            <span class="val">{{item.item_order_price}}元/件</span>
                        </div></el-col>
                    </el-row>
                </div>
                <div class="take-order-table mgt-24">
                    <table class="table">
                        <thead>
                            <tr class="th">
                                <th width="20%">颜色</th>
                                <th width="20%">尺码</th>
                                <th width="30%">锁仓数</th>
                                <th width="">锁仓小计</th>
                            </tr>
                        </thead>               
                        <tbody v-for="(p_item, p_index) in item.group" :key="p_index">
                            <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index" >
                            <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
                            <td>{{s_item.name}}</td>
                            <td>
                                {{s_item.sizelockNumber}}
                            </td>
                            <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.colorChoseTotal}}</td>
                            </tr>             
                        </tbody>
                    </table>
                </div>
                <div class="gap-line"></div>
            </div>
        </div>
        <!-- 核销组件 -->
         <establish v-show="isShowEstablish" :info="currentOrderInfo" @close="closeEstablish" @success="closeEstablishAndSuccess"></establish>
         <paymodal  v-show="isShowPayModal" :info="currentPayModalInfo" @close="closePayModal" @success="closePayModalAndSuccess"></paymodal>
         <checkApplyPayModal  v-show="isShowCheckApplyPayModal" :info="currentCheckApplyPayObj" @close="closeCheckApplyPayModal" @success="closeCheckApplyPayModalAndSuccess"></checkApplyPayModal>
         
         <!-- 去清算的预览 -->
         <el-dialog width="1100px"  center :title="'该商品下共有'+groupModalTable.length+'条'+'下单记录，将会同时清算'"  :visible.sync="isShowGroupModal">
             <div class="clear-sure-top">
                <el-image
                     class="img"
                     :src="imgUrl"
                     fit="cover"
                 >
                 </el-image>
                 <div class="info">
                     <span>名称：{{orderDetail.item_name}}</span> <br>
                     <span>款号：{{orderDetail.item_style_number}}</span>
                 </div>
             </div>
           <el-table :data="groupModalTable" size="small">
             
             <el-table-column property="order_number" label="下单订单号" width="160"></el-table-column>
             <el-table-column property="order_purchase_quantity" label="下单数量"  width="80"></el-table-column>
             <el-table-column property="item_order_price" label="核销价/元" width="85"></el-table-column>
             <el-table-column property="sumEstablishQuantity" label="已核销" width="100"></el-table-column>
             <el-table-column property="needPay" label="已出账单需支付" width="110"></el-table-column>
             <el-table-column property="sumPay" label="平台已确认金额" width="110"></el-table-column>
             <el-table-column property="amountToBeConfirmed" label="平台未确认金额" width="110"></el-table-column>
             <el-table-column property="unpaidAmount" label="已出账单欠款" width="100"></el-table-column>
             <el-table-column property="order_submit_time" label="下单时间" ></el-table-column>
           </el-table>
           <div slot="footer" class="dialog-footer">
               <el-button @click="isShowGroupModal = false">取消</el-button>
               <el-button type="primary" @click="startLiquidate">确定清算</el-button>
           </div>
         </el-dialog>


    </div>
</template>

<script>
import { 
    getReserverOrderInfo, getOrderReserveInfo, updateReserverOrderState, 
    getOrderEstablish, getBillList, confirmTransferPayment
} from '../../../api/supplier'
import {sendBillInfo,getOrderPurchaseList,launchLiquidate,checkPaymentStatus,applicationList} from '../../../api/dealer'
import { supplierLockOrderState, supplierOrderState } from '../../../utils/order-state'
import { accMul, accDiv, accSub ,computeSub} from '../../../utils/tools'
import establish from '../../../components/establishModal'
import paymodal from '../../../components/paymodal'
import checkApplyPayModal from '../../../components/checkApplyPayModal'

import { mapGetters } from 'vuex'
import NP from 'number-precision'

export default {
    data() {
        return {
            groupModalTable:[],
            isShowGroupModal:false,
            isShowEstablish:false,//核销弹窗
            isShowPayModal:false,//付款弹窗
            currentOrderInfo:{},//核销弹窗 需要传递的参数
            currentPayModalInfo:{},//付款弹窗 需要传递的参数

            supplierLockOrderState,  // 所有锁仓订单状态值
            supplierOrderState, // 所有下单订单状态值
            orderState: 'not received', // 当前订单状态值
            orderTakedStateText: '', // 已下单的订单状态
            clearState:'',
            checkState:'',
            payState:'',
            stateWord:{
              noNeed:"不需",
              not:"待",
              part:"部分",
              all:"全部"
            },
            // 下单订单详情
            orderDetail: {
                dealer_user_id: '',
                item_id: '',
                item_main_image_id: '',
                item_name: '',
                item_order_price: '',
                item_style_number: '',
                item_thumbnail_image_id: '',
                lOrderId: '',
                order_content: '',
                order_id: '',
                order_number: '',
                order_purchase_amount: '',
                order_purchase_quantity: '',
                order_state: '',
                order_submit_time: '',
                order_user_address_id: '',
                parent_order_id: '',
                productMainImageFile: '',
                supplier_user_id: '',
                sumEstablishQuantity: '',
                itemFeeSplitting: '',
                supplier_rate: '',
                dealer_rate: '',
                addressInfo: {
                    address_contact_name: "",
                    address_contact_phone: "",
                    address_string: "",
                    region_district_string: "",
                    region_city_string: "",
                    region_province_string: "",
                }
            },
            // 详情图片
            imgUrl: '',
            srcList: [],

            // 锁仓尺码数据
            lockSizeColorArr: [],

            // 下单尺码数据
            orderSizeColorArr: [],

            // 历史锁单列表
            historyLockOrderList: [],

            // 核销记录
            checkSaleHistory: [],

            // 账单列表
            billList_dealer: [],
            billList_platform: [],
            liquidateOrderNumber:'',
            liquidateOrderId:'',
            
            applyLists:[],
            billList_apply:[],
            
            isShowCheckApplyPayModal:false,
            currentCheckApplyPayObj:{}
            
            

            
        }
    },
    created () {
        this.getReserverOrderInfo()
    },
    computed: {
        ...mapGetters(['userId', 'globalServiceCharge']),
        serviceFeeShow: function () {
            return NP.times(100, this.globalServiceCharge) + '%'
        },
    },
    components:{
        establish,paymodal,checkApplyPayModal
    },
    methods: {
        openCheckApplyPay(list){
            this.isShowCheckApplyPayModal=true
            this.currentCheckApplyPayObj=list
            this.currentCheckApplyPayObj.orderNumberShow=this.$route.query.orderNumber
        },
        getApplyList(){
            this.applyLists=[]
            applicationList({
                orderPurchaseNumber: this.$route.query.orderNumber
            }).then(res=>{
                if(res.errorCode==200){
                    this.applyLists=res.data.map(function(item,index){
                        console.log(item)
                        item.imgArr=item.image_file ? item.image_file.split(',').map(ele => ele ? process.env.VUE_APP_IMG_PREV + ele : '') : []
                        return item
                    })
                    
                }else{
                     // this.$message.error(res.errorMsg)
                }
            })
        },
        toLiquidationDetail(){
            this.$router.push('/dealer/order/detail-clear?orderId=' + this.liquidateOrderId)
        },
        // 清算
        startLiquidate(){//清算
             let _this=this
             checkPaymentStatus({
                 supplierUserId:this.orderDetail.supplier_user_id,
                 "dealerUserId":this.userId,
                 "itemId":this.orderDetail.item_id,
             }).then(res=>{
                 if(res.errorCode==200){
                     this.$confirm('您确定发起清算吗?', '提示', {
                         confirmButtonText: '确定',
                         cancelButtonText: '取消',
                         type: 'warning'
                     }).then(() => {
                         launchLiquidate({
                             "supplierUserId":this.orderDetail.supplier_user_id,
                             "dealerUserId":this.userId,
                             "itemId":this.orderDetail.item_id,
                             "orderState":"2",
                             "orderSubmitType":"dealer"
                         }).then(res => {
                             console.log(res)
                             if (res.errorCode == 200) {
                                 this.$message.success(res.errorMsg || '操作成功')
                                  _this.isShowGroupModal=false
                                 this.getReserverOrderInfo()
                             } else {
                                 this.$message.error(res.errorMsg || '操作是失败')
                             }
                         }).catch(err => {
                             console.log(err)
                         })
                     })
                 }else{
                     this.$message.error("有付款凭证未审核，请等待所有付款凭证审核完成后才能发起清算")
                 }
             }) 
            
            // this.$router.push('/dealer/order/liquidation?orderId=' + this.currentModalObj.order_id)
        },
        openToClearModal(){
            let _this = this
            let arg = {
                "supplierUserId": this.orderDetail.supplier_user_id,
                "dealerUserId": this.userId,
                "itemId": this.orderDetail.item_id,
            }
            getOrderPurchaseList(arg).then(res => {
                // console.log(res)
                if (res.errorCode == 200) {
                    _this.groupModalTable = res.data
                    _this.isShowGroupModal=true
                    // if(_this.groupModalTable.length>1){
                    //     _this.isShowGroupModal=true
                    // }else{
                    //     _this.startLiquidate()
                    // }
                } else {
                    _this.groupModalTable = []
                }
            })
        },
        checkClick(){
            this.isShowEstablish=true
            //核销弹窗里的参数
            console.log(this.orderDetail)
            this.currentOrderInfo={
                orderId:this.orderDetail.order_id,
                itemId:this.orderDetail.item_id,
                haveEstablishTotal:this.orderDetail.sumEstablishQuantity,
                leftEstablishTotal:this.orderDetail.order_purchase_quantity-this.orderDetail.sumEstablishQuantity,
                totalEstablish:this.orderDetail.order_purchase_quantity,
                supplierUserId:this.orderDetail.supplier_user_id,
                establishOrderInfo:'',
            }
            // //付款弹窗里的参数
            // this.currentPayModalInfo={
            //     orderId:detail.order_number,
            //     itemId:detail.item_id,
            //     billOrderId:'',
            //     haveEstablishTotal:detail.sumEstablishQuantity,
            //     leftEstablishTotal:detail.order_purchase_quantity-detail.sumEstablishQuantity,
            //     totalEstablish:detail.order_purchase_quantity,
            //     supplierUserId:detail.supplier_user_id,
            //     establishOrderInfo:'',
            //     order_bill_amount:'',
            //     chargeBalance:'',
            // }
        },
        payClick(list){
            console.log(list)
            this.currentPayModalInfo={
                orderId:this.orderDetail.order_number,
                itemId:this.orderDetail.item_id,
                billOrderId:list.order_id,
                haveEstablishTotal:this.orderDetail.sumEstablishQuantity||0,
                leftEstablishTotal:this.orderDetail.order_purchase_quantity-this.orderDetail.sumEstablishQuantity,
                totalEstablish:this.orderDetail.order_purchase_quantity,
                supplierUserId:this.orderDetail.supplier_user_id,
                establishOrderInfo:'',
                order_bill_amount:list.order_bill_amount||0,
                order_pay_amount:list.order_pay_amount||0,
                chargeBalance:list.rest_pay_amount||0,
                amountToBeConfirmed:list.amountToBeConfirmed||0,
                rest_pay_amount_subConfirm:list.rest_pay_amount_subConfirm||0
                
            }
            console.log(this.currentPayModalInfo)
            this.isShowPayModal=true
        },
        closeEstablish(){
            this.isShowEstablish=false
        },
        
        closeEstablishAndSuccess(){
            this.isShowEstablish=false
            this.getReserverOrderInfo()
        },
        closePayModal(){
            this.isShowPayModal=false
        },
        closePayModalAndSuccess(){
            this.isShowPayModal=false
            //刷新页面
            this.getReserverOrderInfo()
        },
        closeCheckApplyPayModal(){
            this.isShowCheckApplyPayModal=false
        },
        closeCheckApplyPayModalAndSuccess(){
            this.isShowCheckApplyPayModal=false
            //刷新页面
            this.getReserverOrderInfo()
            
        },
        // 获取订单数据
        getReserverOrderInfo() {
            getReserverOrderInfo({
                orderPurchaseNumber: this.$route.query.orderNumber
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    let detail = res.data[0]
                    this.orderState = detail.order_state
                    this.orderDetail = detail
                    this.imgUrl = process.env.VUE_APP_IMG_PREV + detail.productMainImageFile
                    this.srcList.push(this.imgUrl)
                    
                    this.orderDetail.supplier_rate = this.orderDetail.itemFeeSplitting ? accMul(this.orderDetail.itemFeeSplitting.split(',')[1], 100) : ''
                    this.orderDetail.dealer_rate = this.orderDetail.itemFeeSplitting ? accMul(this.orderDetail.itemFeeSplitting.split(',')[0], 100) : ''
                    
                    try {
                        let group = JSON.parse(detail.order_content)
                        let arr = group.group
                        this.orderSizeColorArr = arr || []
                        console.log(this.orderSizeColorArr)
                    } catch (error) {
                        console.log(error)
                        this.orderSizeColorArr = []
                    }
                    
                    if (detail.reserverOrderInfoList && detail.reserverOrderInfoList.length > 0) {
                        this.historyLockOrderList = detail.reserverOrderInfoList.map(item => {
                            let group = []
                            try {
                                let order_content = JSON.parse(item.order_content)
                                group = order_content.group
                            } catch (error) {
                                console.log(error)
                            }
                            return {
                                ...item,
                                group
                            }
                        })
                    } 
                    console.log(this.historyLockOrderList)
                    this.getApplyList()
                    this.getOrderEstablish(detail.order_id)
                    this.getBillList(1)
                    this.getBillList(2)
                    this.getBillList(5)
                    // this.getBillList(3)
                    // 订单状态
                    
                    
                    let clearState=''
                    if(detail.liquidateState==4){
                        clearState="已转为清算"
                        this.liquidateOrderNumber=detail.liquidateOrderNumber
                        this.liquidateOrderId=detail.liquidateOrderId
                    }
                    let checkState=''
                    if(!detail.sumEstablishQuantity){
                        checkState="not"
                    }else if(detail.sumEstablishQuantity>0&&detail.order_purchase_quantity>detail.sumEstablishQuantity){
                        checkState="part"
                    }else if(detail.order_purchase_quantity==detail.sumEstablishQuantity){
                        checkState="all"
                    } 
                    let payState=''
                    //paidAmount 已经付过款的, unpaidAmount 待付款
                    if((!detail.paidAmount||Number(detail.paidAmount) <=0) &&(!detail.unpaidAmount|| Number(detail.unpaidAmount) <=0)){
                        payState="noNeed"
                    }else if(!detail.paidAmount||detail.paidAmount<=0){
                        payState="not"
                    }else if(!detail.unpaidAmount||detail.unpaidAmount<=0){
                        payState="all"
                    }else{
                        payState="part"
                    }
                    // if((!detail.paidAmount||Number(detail.paidAmount) <=0) &&(!detail.unpaidAmount|| Number(detail.unpaidAmount) <=0)){
                    //     payState="noNeed"
                    // }else if(!detail.paidAmount){
                    //     payState="not"
                    // }else if(detail.paidAmount>0&&detail.paidAmount<detail.unpaidAmount){
                    //     payState="part"
                    // }else if(detail.paidAmount==detail.unpaidAmount){
                    //     payState="all"
                    // }else{
                    //     alert(3)
                    // }
                    this.clearState=clearState
                    this.checkState=checkState
                    this.payState=payState
                    // this.orderTakedStateText=isClear+' '+checkState+' '+payState
                    
                }
                // dealer_user_id: "417"
                // item_id: "3051"
                // item_main_image_id: 26497
                // item_name: "测试商品111"
                // item_order_price: 123
                // item_style_number: "kd343252"
                // item_thumbnail_image_id: 26497
                // order_content: "{"group":[{"color":"白色","sizeArr":[{"stock_unavailable_total_quantity":0,"number":2,"stock_user_id":5403,"name":"S","stock_item_id":3053,"stock_sale_total_quantity":0,"stock_current_total_quantity":2,"stock_id":357,"stock_grand_total_quantity":2},{"stock_unavailable_total_quantity":0,"number":2,"stock_user_id":5403,"name":"M","stock_item_id":3054,"stock_sale_total_quantity":0,"stock_current_total_quantity":2,"stock_id":358,"stock_grand_total_quantity":2},{"stock_unavailable_total_quantity":0,"number":2,"stock_user_id":5403,"name":"L","stock_item_id":3055,"stock_sale_total_quantity":0,"stock_current_total_quantity":2,"stock_id":359,"stock_grand_total_quantity":2}]}]}"
                // order_id: "68"
                // order_number: 4507513005162088
                // order_reserve_quantity: 36
                // order_state: 2
                // order_submit_time: "2020-05-07 16:51:47"
                // parent_order_id: "82"
                // productMainImageFile: "/static/digitalWarehouse/12101/2020/04/28/823734f5846a71253374096002633165.jpg"
                // supplier_user_id: "5403"
            }).catch(err => {
                console.log(err)
            })
        },
        // 发起销售商账单
        sendBillInfo() {
          this.$confirm('确认发起销售商账单吗', '提示', {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              sendBillInfo({
                "orderPurchaseNumber": this.$route.query.orderNumber
              }).then(res => {
                if (res.errorCode == 200) {
                  this.$message.success(res.errorMsg || '操作成功')
                  this.getBillList(1)
                  this.getBillList(2)
                } else {
                  this.$message.error(res.errorMsg || '操作失败')
                }
              })
          })
        },
        

        // 获取核销数据
        getOrderEstablish(orderId) {
            getOrderEstablish({
                orderId
            }).then(res => {
                console.log(res)
                if (res.errorCode == 200) {
                    let unitPrice,supplierRate,sumMoney
                    unitPrice = this.orderDetail.item_order_price
                    supplierRate = this.orderDetail.itemFeeSplitting ? this.orderDetail.itemFeeSplitting.split(',')[1] : ''
                   
                    
                    this.checkSaleHistory = res.data.map(item => {
                        let quantityObj = JSON.parse(item.order_content)
                        try {
                            let s1 = accMul(unitPrice, quantityObj.orderEstablishQuantity)
                            let s2 = accMul(s1, supplierRate)
                            sumMoney = s2.toFixed(2)
                        } catch (error) {
                            sumMoney = '--'
                        }
                        return {
                            ...item,
                            orderEstablishQuantity: quantityObj.orderEstablishQuantity,
                            beforeOrderQuantity: quantityObj.beforeOrderQuantity,
                            restQuantity: quantityObj.beforeOrderQuantity - quantityObj.orderEstablishQuantity,
                            unitPrice: unitPrice,
                            supplierRate: accMul(Number(supplierRate), 100),
                            sumMoney: sumMoney
                        }
                    })
                }
            }).catch(err => {
                console.log(err)
            })
        },
        // 获取账单信息  1 - 销售商  2 - 平台  3 - 清算账单
        getBillList(type) {
            getBillList({
                billType: type,
                orderPurchaseNumber: this.orderDetail.order_number,
                liquidateOrderId: this.orderDetail.lOrderId
            }).then(res => {
                console.log(res);
                if (res.errorCode == 200) {
                    if (type == 1) {
                        this.billList_dealer = res.data.map(element => {
                            return {
                                ...element,
                                order_bill_amount: (+element.order_bill_amount).toFixed(2),
                                order_pay_amount: (+element.order_pay_amount).toFixed(2) || 0,
                                rest_pay_amount:computeSub(element.order_bill_amount ,element.order_pay_amount) ,// element.order_pay_amount ? (element.order_bill_amount - element.order_pay_amount).toFixed(2) : (+element.order_bill_amount).toFixed(2),
                                rest_pay_amount_subConfirm:computeSub(element.order_bill_amount,element.order_pay_amount,element.amountToBeConfirmed),
                                
                                orderEstablishList: element.orderEstablishList ? element.orderEstablishList.map(item => {
                                    let unitPrice, supplierRate, sumMoney;
                                    unitPrice = this.orderDetail.item_order_price;
                                    supplierRate = this.orderDetail.itemFeeSplitting
                                    ? this.orderDetail.itemFeeSplitting.split(",")[1]
                                    : "";
                                    let quantityObj = JSON.parse(item.order_content);
                                    try {
                                    let s1 = accMul(unitPrice, quantityObj.orderEstablishQuantity);
                                    let s2 = accMul(s1, supplierRate);
                                    sumMoney = s2.toFixed(2);
                                    } catch (error) {
                                    sumMoney = "--";
                                    }
                                    return {
                                    ...item,
                                    orderEstablishQuantity: quantityObj.orderEstablishQuantity,
                                    beforeOrderQuantity: quantityObj.beforeOrderQuantity,
                                    restQuantity:
                                        quantityObj.beforeOrderQuantity -
                                        quantityObj.orderEstablishQuantity,
                                    unitPrice: unitPrice,
                                    supplierRate: accMul(Number(supplierRate), 100),
                                    sumMoney: sumMoney
                                    };
                                }).reverse() : [],
                                orderPaymentList: element.orderPaymentList ? element.orderPaymentList.map(item => {
                                    return {
                                    ...item,
                                    imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? process.env.VUE_APP_IMG_PREV + ele : '') : []
                                    }
                                }) : []
                            }
                        });
                  
                    }
                    if (type == 2) {
                        this.billList_platform = res.data.map(element => {
                            return {
                            ...element,
                            order_bill_amount: (+element.order_bill_amount).toFixed(2),
                            order_pay_amount: (+element.order_pay_amount).toFixed(2) || 0,
                            rest_pay_amount: element.order_pay_amount ? (element.order_bill_amount - element.order_pay_amount).toFixed(2) : element.order_bill_amount.toFixed(2),
                            orderTransferList: element.orderTransferList ? element.orderTransferList.map(item => {
                                return {
                                ...item,
                                imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? process.env.VUE_APP_IMG_PREV + ele : '') : []
                                }
                            }) : []
                            }
                        });
                    }
                    if (type == 5) {//销售商申请平台打款，平台同意后生成的账单
                        this.billList_apply = res.data.map(element => {
                          return {
                            ...element,
                            orderPaymentList: element.orderPaymentList ? element.orderPaymentList.map(item => {
                              return {
                                ...item,
                                imageFiles: item.image_file ? item.image_file.split(',').map(ele => ele ? process.env.VUE_APP_IMG_PREV+
                                  ele : '') : []
                              }
                            }) : []
                          }
                        });
                    }
                    
                } else {
                    
                }
            }).catch(err => {
                console.log(err)
            })
        },

        // 平台付款明细
        getPlatformPayDetail (item, pay_ele) {
            this.platformPeriodPayDetail = item;
            this.platformSinglePayDetail = pay_ele;
            this.platformPopShowData = {
                sumAmount: (+item.order_bill_amount).toFixed(2),
                hadPaidAmount: (+item.order_pay_amount).toFixed(2),
                restPayAmount: (item.order_bill_amount - item.order_pay_amount).toFixed(2),
                currentPay: (+pay_ele.order_payment_amount).toFixed(2),
                debt: (item.order_bill_amount - item.order_pay_amount - pay_ele.order_payment_amount).toFixed(2)
            }
            this.supplierSurePlatformPayPop = true;
        },
       
        
    }
}
</script>

<style lang="scss" scoped>
 .mt10{margin-top: 10px;}
.bold{font-weight: bold;}
.smallNumber{font-size: 12px;color:royalblue;cursor: pointer;}
.smallNumber:hover{color:darkblue}

.stateInline{display: inline-block;margin-right: 20px;;}

.page-wrapper {
    min-width: 1030px;
}
.test-btns {
    position:absolute; right: 10px; top: 10px;
}
.page-section {
    padding: 24px 24px;
    background: #fff;
    margin-bottom: 16px;
}
.header-handle-box {
    min-width: 980px;
    box-sizing: border-box;
    margin-top: 24px;
    border: 1px solid #e6e6e6;
    background: #fafafa;
    padding: 40px 80px;
    .state {
        font-size: 20px;
        color: #333;
        font-weight: 500;
        &.red {color: #F81D22;}
    }
    .btns {
        margin-top: 40px;
        .cg-btn {margin-right: 20px;}
    }
    .tip {
        margin-top: 14px;
        height:20px;
        font-size:14px;
        color:rgba(51,51,51,0.6);
        line-height:20px;
    }
    .tip-small {
        margin-left: 8px;
        height:20px;
        font-size:14px;
        color:rgba(51,51,51,0.6);
        font-size: normal;
        line-height:20px;
    }
}
.basic-info {
    &.mgt-24 {
        margin-top: 24px;
    }
    &.mgt-40 {
        margin-top: 40px;
    }
    .line {
      padding-bottom: 16px;
      font-size:14px;
      line-height:22px;
      .lab {
        color:rgba(0,0,0,0.85);
      }
      .val {
        color:rgba(0,0,0,0.65);
      }
      &.blue .lab , &.blue .val { color: #1890FF}
      .green { color: #52C41A;}
      .text-btn {
          margin-left: 16px;
          background: transparent;
          border: none;
          font-size: 14px;
          color: #1890FF;
          outline: none;
          cursor: pointer;
          &:hover {
              text-decoration: underline;
          }
      }
    }
}
.order-detail-table {
    margin-top: 24px;
    .table {
        border: 1px solid #E6E6E6;
        width: 100%;
        min-width: 980px;
        border-spacing: 0;
        border-collapse: collapse;
        font-size:14px;
        tr.th {
            background: #fafafa;
            height: 55px;
        }
        tr th {
            color:rgba(0,0,0,0.85);
            font-weight: normal;
        }
        td {
            padding: 32px 24px 0;
            color:rgba(0,0,0,0.85);
            text-align: center;
            vertical-align: top;
        }
        tr:last-child td {
            padding-bottom: 32px;
        }
        .td-1-wrap {
            height: 100px;
            .img {
                border: 1px solid #f0f0f0;
                float: left;
                width: 100px;
                height: 100px;
                margin-right: 24px;
            }
            .title {
                text-align: left;
            }
        }
    }
    .rate-info {
        margin-top: 15px;
    }
}
.goods-size-list {
    border: 1px solid #E6E6E6;
    border-top: none;
    &.mgt-24 {
        margin-top: 24px;
    }
    .color-list {
        .color-head {
            color:rgba(0,0,0,0.85);
            font-weight: normal;
            height: 50px;
            padding: 0 80px 0 48px;
            line-height: 50px;
            border-bottom: 1px solid #E6E6E6;
            border-top: 1px solid #E6E6E6;
            background: #fafafa;
            .t1 {float: left; width: 300px;}
            .t2 {float: left;}
        }
        .size-wrap {
            padding: 24px 24px 0 48px;
        }
        .size-list {
            th, td {
                width: 100px;
                padding: 0 0 24px 0;
                font-size: 14px;
                color:rgba(0,0,0,0.85);
            }
            th {
                text-align: left;
                font-weight: normal;
            }
        }
    }
}

.agree-lock-tips {
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 10px;
}
.take-order-table {
  &.scroll {
      height: 50vh;
      overflow-y: auto;
      overflow-x: visible;
  }
  .table {
    border: 1px solid #E6E6E6;
    width: 100%;
    min-width: 980px;
    border-spacing: 0;
    border-collapse: collapse;
    font-size:14px;
    tr {
      height: 50px;
    }
    tr.th {
      background: #fafafa;
    }
    tr th {
      color:rgba(0,0,0,0.85);
      font-weight: normal;
    }
    td {
      border: 1px solid #E6E6E6;
      text-align: center;
      color:rgba(0,0,0,0.85);
    }
    &.min-400 {
        min-width: 400px;
    }
  }
  &.mgt-24 {
      margin-top: 24px;
  }
  &.clearing {
      margin-top: 24px;
  }
  &.clearing tr th {
    border: 1px solid #E6E6E6;
  }
  &.clearing tr th:last-child, &.clearing tr td:last-child{
    color: #F81D22;
  }
  
}

.gap-line {
    margin: 40px 0;
    height: 1px;
    background: #E6E6E6;
}

.time-line {
  margin-top: 24px;
  list-style: none;
  .item {
    position: relative;
    .item-tail {
      position: absolute;
      top: 6px;
      left: 4px;
      width: 2px;
      height: 100%;
      background: #f7f7f7;
    }
    .item-node {
      position: absolute;
      top: 6px;
      left: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #d9d9d9;
    }
    &:first-child .item-node {
      background: #f81d22;
    }
    &:last-child .item-tail {
      width: 0;
    }
    .item-content {
      padding-left: 32px;
      font-size: 14px;
      font-weight: 500;
      width: 800px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      padding-bottom: 16px;
    }
    .item-tit {
      padding-bottom: 8px;
      .item-tit-strong {
          font-size: 14px;
          color: #000;
          font-weight: bold;
      }
      .item-tit-during {
          font-size: 13px;
          color: #000;
      }
    }
    .item-sum-data {
        background: rgba(5, 4, 4, 0.02);
        padding: 16px 24px;
        position: relative;
        &::after {
            content: ' ';
            height: 1px;
            border-bottom: 1px dashed #ccc;
            position: absolute;
            left: 24px;
            right: 24px;
            bottom: 0;
        }
    }
    .item-box {
      background: rgba(5, 4, 4, 0.02);
      border-radius: 2px;
      padding: 24px;
      .img {
        width: 100px; height: 100px; border: 1px solid #eee;
        vertical-align: top; margin-right: 4px;
      }
      .pay-info {
        display: inline-block;
        width: 400px;
        margin-left: 10px;
        font-size: 13px;
      }
      .pdb-12 {
        padding-bottom: 12px;
      }
      .pdb-6 {
        padding-bottom: 6px;
      }
      .grey {
        color: rgba(0, 0, 0, 0.45);
      }
      .green {
        color: #52c41a;
      }
      .blue {
        color: #1890ff;
      }
    }
  }
  .sub-time-line {
    list-style: none;
    .sub-item {
      position: relative;
      padding-left: 24px;
      .title {
        display: inline-block;
        width: 450px;
      }
      .time {font-size: 13px; color: #000; margin-right: 6px;}
      &::before {
        content: " ";
        position: absolute;
        top: 15px;
        left: 3px;
        width: 1px;
        height: calc(100% - 12px);
        background: #d8d8d8;
      }
      &::after {
        content: " ";
        position: absolute;
        top: 6px;
        left: 0;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #fff;
        border: 1px solid #d8d8d8;
        box-sizing: border-box;
      }
      &:first-child::after {
        background: #ff9c6e;
        border: 1px solid #ff9c6e;
      }
      &:last-child::before {
        width: 0;
      }
    }
  }
}

.address-wrap {
    padding-top: 16px;
}
.address-label {
    font-size: 14px;
    font-weight: 500;
    color: #666;
    line-height: 30px;
}
.address-content {
    padding: 6px 0px ;
    color: #333;
    font-size: 13px;
    .line {
        margin-bottom: 6px;
        &:last-child {margin-bottom: 0;}
    }
    .gap {
        margin-left: 30px;
    }
}

.clear-sure-top {
        height: 64px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;
        .img {width: 64px; height: 64px; float: left; border: 1px solid #eee}
        .info {padding-left: 80px;}
        .count {position: absolute; right: 0; bottom: 10px; font-size: 12px; color: #333; line-height: 1;}
    }

</style>